export default __webpack_public_path__ + "static/media/8.08bb1d40.jpg";